import React, { useRef } from "react";
import DatePicker from "react-datepicker";
import { InputGroup, InputGroupText } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";

export const CommonMyDatePicker = ({
  label,
  value,
  onChange,
  disabled = false,
  name,
  maxDate,
  minDate,
  placeholderText,
}) => {
  const date = value ? new Date(value) : null;
  const datePickerRef = useRef(null);

  return (
    <div className="form-group w-100">
      {label && <label className="form-label">{label}</label>}
      <InputGroup style={{ flexWrap: "nowrap" }}>
        <DatePicker
          ref={datePickerRef}
          selected={date}
          maxDate={maxDate}
          minDate={minDate}
          onChange={onChange}
          dateFormat="yyyy-MM-dd"
          placeholderText={placeholderText || "Select date"}
          className="form-control"
          disabled={disabled}
          name={name}
          onChangeRaw={(e) => e.preventDefault()}
        />
        <InputGroupText
          role="button"
          style={{ cursor: "pointer" }}
          onClick={() => datePickerRef.current.setOpen(true)}
        >
          <span className="mdi mdi-calendar-month-outline" />
        </InputGroupText>
      </InputGroup>
    </div>
  );
};
